<i18n>
{
  "en": {
    "nav_home": "Home",
    "nav_participants": "Participants",
    "nav_settings": "Settings"
  },
  "sv": {
    "nav_home": "Hem",
    "nav_participants": "Deltagare",
    "nav_settings": "Inställningar"
  }
}
</i18n>

<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="currentUser && currentUser.isAdmin"
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>
        <v-list-tile @click="goToHome">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{$t('nav_home')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--
        <v-list-tile @click="goToParticipants">
          <v-list-tile-action>
            <v-icon>account_box</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{$t('nav_participants')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        -->
        <div v-if="currentUser && currentUser.isAdmin" @click="goToSettings">
          <v-divider></v-divider>
          <v-list-tile >
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{$t('nav_settings')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="teal darken-3" dark fixed app>
      <v-toolbar-side-icon @click.stop="toggleDrawer" v-if="currentUser && currentUser.isAdmin"></v-toolbar-side-icon>
      <v-icon v-if="isElectron" @click.stop="back">chevron_left</v-icon>
      <v-toolbar-title @click="goToHome" class="brand-name font-weight-light">CADDIE</v-toolbar-title>
      <v-spacer></v-spacer>
      <div >
        <CurrentUser/>
      </div>
      <v-icon v-if="isElectron" @click.stop="quit" class="ml-4">close</v-icon>
    </v-toolbar>

    <v-content>
      <router-view/>
    </v-content>

  </v-app>
</template>
<style scoped>
.v-toolbar {
  -webkit-user-select: none;
  -webkit-app-region: drag;
}
.v-toolbar button, .v-toolbar div:not(.spacer), .v-toolbar .v-icon {
  -webkit-app-region: no-drag;
}
</style>
<script>
//import Welcome from './components/Welcome'
  import CurrentUser from './components/CurrentUser'

  export default {
    name: 'App',
    components: {
      //Welcome,
      CurrentUser,
    },
    computed: {
      token() { return localStorage.token },
      currentUser() { return this.$store.state.currentUser },
      isElectron() { return window && window.process && window.process.versions['electron'] },
    },
    data () {
      return {
        drawer: localStorage.drawer === 'true'
      }
    },
    created(){
      console.log(typeof(localStorage.token))
      if(localStorage.token == "null" || localStorage.token == "undefined"){
        this.$router.push({ name: 'userSelect'})
      }
    },
    methods: {
      toggleDrawer () {
        this.drawer = !this.drawer
        localStorage.drawer = this.drawer
      },
      goToHome () {
        this.$router.push({ name: 'home'})
      },
      goToSettings () {
        this.$router.push({ name: 'settings'}) //params: ... 
      },
      goToParticipants() {
        this.$router.push({ name: 'participantOverview'})
      },
      back() {
        if (history.length > 0) history.back()
      },
      quit() {
        window.close()
      }
    }
  }
</script>

<style scoped>
  .brand-name { cursor: pointer; }
</style>